var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3034_1095)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52694 4.48279C10.2084 1.32613 14.9757 -0.270589 19.8157 0.0319153C24.6558 0.334419 29.1872 2.5123 32.4469 6.10279C34.0364 7.86538 35.2566 9.92853 36.0356 12.1705C36.8146 14.4124 37.1365 16.7877 36.9824 19.1561C36.8283 21.5245 36.2013 23.838 35.1383 25.9601C34.0754 28.0822 32.5981 29.9698 30.7936 31.5116C27.1122 34.6682 22.3449 36.265 17.5048 35.9625C12.6648 35.66 8.13342 33.4821 4.87364 29.8916C3.28487 28.1287 2.06524 26.0654 1.28668 23.8236C0.508116 21.5817 0.186393 19.2066 0.340487 16.8384C0.494581 14.4702 1.12137 12.1569 2.18388 10.0348C3.2464 7.91276 4.72312 6.02497 6.52694 4.48279Z",
    fill: "#D82427"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7487 5.39891C14.0429 5.42051 14.8916 7.27451 14.6387 9.53891C14.3858 11.8033 13.1375 13.6213 11.8433 13.5952C10.5491 13.5691 9.70038 11.7196 9.95328 9.4552C10.2062 7.19081 11.4545 5.37551 12.7487 5.39891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2451 9.64425C26.1964 8.73615 27.6652 9.13665 28.5247 10.5442C29.3843 11.9518 29.3132 13.8202 28.3619 14.7283C27.4105 15.6364 25.9417 15.2359 25.0831 13.8283C24.2245 12.4207 24.2938 10.5469 25.2451 9.64425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2653 25.3602C22.2653 25.3602 22.1078 22.3191 25.0508 17.9091C25.0508 17.9091 26.9327 15.0399 28.8083 15.0561C28.8083 15.0561 30.5489 14.8104 33.0338 17.5761C34.5694 19.2554 35.6381 21.3078 36.1334 23.5287C35.5587 22.6782 34.907 21.8823 34.1867 21.1509C33.0652 19.8495 31.5746 18.9195 29.9126 18.4842C29.1277 18.3452 28.3206 18.4028 27.5633 18.6517C26.806 18.9006 26.1222 19.3331 25.5728 19.9107C24.6258 20.9253 23.8309 22.0718 23.213 23.3145C22.8647 23.9769 22.5497 24.6555 22.2617 25.3503L22.2653 25.3602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86827 28.4965C3.86827 28.4965 3.60727 23.5213 7.72927 17.3446C7.72927 17.3446 10.1494 13.7212 12.9007 13.8283C12.9007 13.8283 15.4513 13.6357 18.5509 17.5372C18.5509 17.5372 21.6937 21.4594 22.2598 25.36C19.7587 21.9238 15.3046 15.0523 10.0891 19.4389C8.85634 20.5268 7.77402 21.774 6.87067 23.1478C5.72112 24.8438 4.71532 26.6329 3.86377 28.4965H3.86827Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3034_1095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.9,
    height: 36,
    fill: "white",
    transform: "translate(0.299805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.3b146551e06ffe74c049fb03b0e52b58.svg";
export { ForwardRef as ReactComponent };